import React, { useState } from "react";
import skuServices from "app/services/sku-services";
import { downloadBuffer } from "app/utils/appHelpers";
import moment from "moment";
import ExcelExportButton from "app/widgets/Shared/ExcelExportButton";

const SKUExportButton = ({
    getExportParams = () => "",
}) => {
    const [exporting, setExporting] = useState(false);

    const exportSkus = async () => {
        try {
            setExporting(true);
            const params = getExportParams();
            const data = await skuServices.exportSkus(params);
            downloadBuffer(data, `skus_export_${moment().format("YYYYMMDDHHmmss")}.xlsx`);
        } catch (_error) {
            // Interceptor handles generic message.
        } finally {
            setExporting(false);
        }
    };

    return (
        <ExcelExportButton size="small" loading={exporting} onClick={exportSkus} />
    );
};

export default SKUExportButton;
